import { NeedDto } from '@act/shared/data-transfer-objects';
import { timeFormatter } from '@act/shared/utilities';

export const NEED_EXPIRING_SOON_DAYS = 7;

export function getDaysUntilNeedExpires(
  need: Pick<NeedDto, 'fulfilledAt' | 'expiresAt'>
): number {
  const dueDate = need.fulfilledAt || need.expiresAt;
  return timeFormatter.differenceInDaysFromNow(dueDate);
}

export function needIsExpiringSoon(
  need: Pick<NeedDto, 'fulfilledAt' | 'expiresAt'>
): boolean {
  const daysUntilExpiration = getDaysUntilNeedExpires(need);
  return daysUntilExpiration <= NEED_EXPIRING_SOON_DAYS;
}
